// extracted by mini-css-extract-plugin
export default {"header":"vQW1f","title":"fVvoa","wrapper":"Cmq9b","wrapperContainer":"kfAeQ","container":"lONi_","mainContentWrapper":"ndQ14","footer":"UpIq7"};